/*eslint-disable*/
import React from "react";
// react components for routing our app without refresh
//import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

// core components
import CustomDropdown from "CustomDropdown/CustomDropdown.jsx";
import Button from "CustomButtons/Button.jsx";

import headerLinksStyle from "./HeaderLinksStyle.jsx";
import Divider from '@material-ui/core/Divider';


class HeaderRightLinks extends React.Component {


render(){
  const { classes, logoutUser } = this.props;
  return (
    <List className={classes.list}>
      <ListItem className={classes.headerRightLinkslistItem}>
        <Button 
          color="white"
          style={{color: "white", backgroundColor: "inherit",
          boxShadow: "none", border: "1px solid"}}
          onClick={logoutUser}
          size="sm"
        >
          Log out
        </Button>
      </ListItem>
    </List>
  );
}
}

export default withStyles(headerLinksStyle)(HeaderRightLinks);
